export default function() {

  let observer;

  const banner = document.querySelector('[data-banner]')
  const bannerSentinal = document.querySelector('[data-banner-sentinal]')

  if (!banner || !bannerSentinal) {
    return
  }

  function createObserver() {

    // If there's an old observer, disconnect it
    if (observer) {
      observer.disconnect();
    }

    // Create a new observer with the updated margin
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            banner.classList.remove('fixed')
          } else {
            banner.classList.add('fixed')
          }
        });
      },
      {
        root: null,
        rootMargin: `0px 0px 0px 0px`,
        threshold: 0
      }
    );

    observer.observe(bannerSentinal)
    console.log(observer)
  }

  window.addEventListener('resize', () => {
    createObserver()
  })

  createObserver()
}